import React from "react";
import PropTypes from "prop-types";
import { Dispatcher } from "../../../flux";
import { Isvg } from "../../../components";
import Highlights from "../../notebook/highlights";

export default class BookHighlights extends React.Component {
  constructor(props) {
    super(props);
    const state = {};
    this.state = Object.assign(state, this.props.savedState);
  }

  openFullBook() {
    this.props.minimize({ "book-highlights": this.state }, () =>
      Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "notebook")
    );
  }

  render() {
    if (this.props.active) {
      return (
        <div className="highlights-container notebook">
          <div className="open-full-book">
            <button className="noButton" onClick={this.openFullBook.bind(this)}>
              {i18n.t("assignments.open-full-notebook")}
            </button>
          </div>

          <Highlights
            isbn={this.props.isbn}
            startCFI={this.props.startCFI}
            endCFI={this.props.endCFI}
            rangeType={this.props.rangeType}
            className="assignment"
            hideReviewMode
            hideSettings
            basicFilters
          />
        </div>
      );
    }
    return null;
  }
}

BookHighlights.propTypes = {
  active: PropTypes.bool.isRequired
};
